import React, { memo } from 'react';
import SortControls from './Sort/SortControls';

const TabLayout = ({ title, showSortControls = false, sortOption, setSortOption, rightContent, children }) => {
    return (
        <div className="flex flex-col h-full">
            <div className="bg-white dark:bg-gray-700 p-4 z-30 border-b border-gray-200 dark:border-gray-900 transition-colors flex items-center justify-between">
                <h2 className="font-semibold">{title}</h2>
                <div className="flex items-center gap-4">
                    {showSortControls && <SortControls sortOption={sortOption} setSortOption={setSortOption} />}
                    {rightContent}
                </div>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto">
                {children}
            </div>
        </div>
    );
};

export default memo(TabLayout);
